import React from "react";

export default function CategoryTile({ category, count, onClick, dataTestId, Icon }) {
  return (
    <button
      data-testid={dataTestId}
      onClick={onClick}
      className="cat-tile text-left p-4 h-[112px] flex flex-col justify-between w-full"
    >
      <div className="flex items-center justify-between">
        <div
          className="w-9 h-9 rounded-md flex items-center justify-center"
          style={{ background: "rgba(255,179,0,0.12)", border: "1px solid rgba(255,179,0,0.25)" }}
        >
          {Icon ? <Icon className="w-4.5 h-4.5" style={{ color: "var(--rs-amber)" }} strokeWidth={2.25} /> : null}
        </div>
        {typeof count === "number" && (
          <span className="font-mono-rs text-[10px] px-1.5 py-0.5 rounded border text-[var(--rs-text-2)]" style={{ borderColor: "var(--rs-border)" }}>
            {count}
          </span>
        )}
      </div>
      <div>
        <div className="font-heading font-bold text-sm leading-tight">{category.name}</div>
        <div className="text-[11px] text-[var(--rs-text-3)] line-clamp-1 mt-0.5">{category.desc}</div>
      </div>
    </button>
  );
}
